import { useState, useRef } from "react";
// models
import {
  Documentos,
  initialValuesDocumentos,
} from "../../../../../models/JuradosModel/infoJurados/infojuradosdocumentos.model";
// api services
import apiParticipantes from "../../../../../api/Participantes/api-participantes";
import apiConvocatorias from "../../../../../api/Convocatorias/api-convocatorias";
import DocumentosService from "../../../../../api/Documentos/api-documentos";
// route
import { useNavigate } from "react-router";
// redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../redux/reducers";
import { openNotification } from "../../../../../utils/saveFile";
import { cambiarPestaña } from "../../../../../redux/actions/convocatoriaAction";
import { ObjNotificaciones } from "../../../../../config/notificaciones";
import Swal from "sweetalert2";
import { useEncrypt } from "../../../../../hooks/useEncrypt";

export const useDocumentos = () => {
  // redux
  const dispatch = useDispatch();
  // const { idConvocatoria } = useSelector((state: RootState) => state.convocatoria);
  const { decrypt, encrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  // const { editarConvocatoria } = useSelector((state: RootState) => state.edicion);
  const editar_convocatoria = decrypt(
    localStorage.getItem("editar_convocatoria")
  );
  let editarConvocatoria = false;
  if (editar_convocatoria !== null) {
    editarConvocatoria = Boolean(editar_convocatoria);
  }
  // state
  const [documento, setDocumento] = useState<Documentos>(
    initialValuesDocumentos
  );
  const [documentos, setDocumentos] = useState<Array<Documentos>>([]);
  const [modalvisualizardocumento, setModalVisualizarDocumento] =
    useState(false);
  const [documentovisualizar, setDocumentoVisulizar] = useState("");
  const [modaleditardocumento, setModalEditarDocumento] = useState(false);
  const [indexdocumento, setIndexDocumento] = useState(0);
  // refs
  const fileInputRef = useRef<any>();
  // route
  const navigate = useNavigate();
  // functions
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (
        e.target.files[0].type === "application/pdf" ||
        e.target.files[0].type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        e.target.files[0].type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        e.target.files[0].type === "image/png" ||
        e.target.files[0].type === "image/jpeg"
      ) {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setDocumento({ ...documento, url_documento: data.data });
      }
      openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos PDF, Word y Excel",
        placement: "bottomRight",
      });
      return setDocumento({ ...documento, url_documento: "" });
    }
  };
  const agregarfila = () => {
    setDocumentos([...documentos, documento]);
    return setDocumento(initialValuesDocumentos);
  };
  const eliminarFila = async (index: number) => {
    let infoupdate = [...documentos];
    if (infoupdate[index].url_documento) {
      await DocumentosService.eliminarArchivo(infoupdate[index].url_documento);
    }
    infoupdate = infoupdate.filter((data: any, i: number) => i !== index);
    infoupdate = infoupdate.map((data: any, i: number) => {
      return {
        ...data,
        index: i,
      };
    });
    return setDocumentos(infoupdate);
  };
  const guardarycontinuar = async () => {
    if (documentos.length === 0) {
      Swal.fire({
        title: "¿Estás seguro de continuar sin adjuntar documentos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then(async (result) => {
        if (result.isConfirmed) {
          await apiConvocatorias.guardarDocumentosadministrativos(
            idConvocatoria,
            documentos
          );
          if (editarConvocatoria) {
            await ObjNotificaciones.MSG_SUCCESS(
              "success",
              `Se ha editado correctamente la convocatoria #${idConvocatoria}`
            );
          } else {
            await ObjNotificaciones.MSG_SUCCESS(
              "success",
              `Se ha creado correctamente la convocatoria #${idConvocatoria}`
            );
          }
          localStorage.setItem("cambiarPestaña", encrypt("1"));
          // dispatch(cambiarPestaña("1"))
          navigate("/administrador");
          return;
        }

        if (result.isDismissed) {
          return;
        }
      });
      return;
    }
    await apiConvocatorias.guardarDocumentosadministrativos(
      idConvocatoria,
      documentos
    );
    if (editarConvocatoria) {
      await ObjNotificaciones.MSG_SUCCESS(
        "success",
        `Se ha guardado correctamente la convocatoria #${idConvocatoria}`
      );
    } else {
      await ObjNotificaciones.MSG_SUCCESS(
        "success",
        `Se ha creado correctamente la convocatoria #${idConvocatoria}`
      );
    }
    localStorage.setItem("cambiarPestaña", encrypt("1"));
    // dispatch(cambiarPestaña("1"))
    navigate("/administrador");
  };
  const cargarConvocatoria = async () => {
    if (editarConvocatoria) {
      let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);

      data.documentos_generales == null
        ? setDocumentos([])
        : setDocumentos(data.documentos_generales);
    }
  };
  const editarFila = () => {
    let infoupdate = [...documentos];
    infoupdate[indexdocumento] = documento;
    console.log(infoupdate, "este es el infoupdate");
    return setDocumentos(infoupdate);
  };
  return {
    documento,
    setDocumento,
    documentos,
    setDocumentos,
    fileInputRef,
    guardarArchivo,
    agregarfila,
    eliminarFila,
    guardarycontinuar,
    cargarConvocatoria,
    modalvisualizardocumento,
    setModalVisualizarDocumento,
    documentovisualizar,
    setDocumentoVisulizar,
    modaleditardocumento,
    setModalEditarDocumento,
    setIndexDocumento,
    indexdocumento,
    editarFila,
  };
};

// const columns
